import React, { useMemo, useReducer } from 'react';
import _get from 'lodash/get';

import { DefaultLoading } from 'components/Loading';
import ErrorPage from 'pages/Error';
import MainLayout from 'components/Layouts/MainLayout';
import { useSelector } from 'react-redux';

import { getMachine } from 'lib/selectors/getMachine';
import { MultiStep } from './MultiStep';
import useStartJob from './useStartJob';

const initialState = {
  filter: '',
  jobs: [],
  job: null,
  workOrderId: '',
};

function reducer(state, action) {
  switch (action.type) {
    case 'SET_FILTER':
      return { ...state, filter: action.filter };
    case 'SET_JOBS':
      return { ...state, jobs: action.jobs };
    case 'SELECT_JOB':
      return { ...state, job: action.job, workOrderId: action.workOrderId };
    default:
      throw new Error(`Unknown action ${action.type}`);
  }
}

const SelectJob = () => {
  const machine = useSelector(getMachine);
  const [state, dispatch] = useReducer(reducer, initialState);
  const { startJob, startJobAsJSG } = useStartJob(state.job);

  const jobName = useMemo(() => {
    return _get(state, ['job', 'displayName'], 'Unknown Operation');
  }, [state]);

  const loading = false;
  const error = false;

  if (loading) return <DefaultLoading />;
  if (error) return <ErrorPage error={error} />;

  return (
    <MainLayout.Container direction="column">
      <MultiStep
        workOrderId={state?.workOrderId}
        machine={machine}
        dispatch={dispatch}
        handleOnBack={() => {}}
        submit={() => {}}
        startJob={startJob}
        startJobAsJSG={startJobAsJSG}
        jobName={jobName}
        {...state}
      />
    </MainLayout.Container>
  );
};

export default SelectJob;
